export function makeBalancePerProduct(response) {
  return response.map((response) => {
    return {
      productName: response.productName,
      username: response.username,
      balance: response.balance,
      currency: response.currency,
    };
  });
}

export function makeOtherDetails(details) {
  return {
      verifiedAt: details.verified_at
  };
}

class OverviewStore {
  constructor(OverviewApiService, DashboardApiService, CustomerApiService, SessionService) {
    'ngInject';

    this.OverviewApiService = OverviewApiService;
    this.DashboardApiService = DashboardApiService;
    this.CustomerApiService = CustomerApiService;
    this.SessionService = SessionService;
    this.currency$ = SessionService.session.map(session => session ? session.currency : {});
  }

  getDashboardDetails() {
    return this.DashboardApiService.dashboard().then((details) => {
      return {
        others: makeOtherDetails(details),
      };
    });
  }

  getHistory(payload) {
    return this.OverviewApiService.getHistory(payload);
  }

  getPaymentOptions() {
    return this.CustomerApiService.getPaymentOptions();
  }

  getBalancePerProduct() {
    return this.CustomerApiService.getProducts(response => makeBalancePerProduct(response));
  }

  getBalance() {
    return this.CustomerApiService.getBalance();
  }

  getStatuses() {
    return this.SessionService.session.map((sessionDetails) => {
      return sessionDetails ? sessionDetails.statuses : {};
    });
  }

  getCustomerProducts() {
    return this.CustomerApiService.getProducts();
  }
}

export default OverviewStore;



// WEBPACK FOOTER //
// ./client/app/pages/customer/overview/service/overview.store.js